import { Wifi, WifiOff } from "lucide-react"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"
import { useTranslation } from "react-i18next"

interface SignalRStatusProps {
  isConnected: boolean
  className?: string
}

export function SignalRStatus({
  isConnected,
  className,
}: Readonly<SignalRStatusProps>) {
  const { t } = useTranslation()

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={cn(
              "flex items-center gap-1.5 rounded-md px-2 py-1 text-xs",
              className,
            )}
          >
            {isConnected ? (
              <>
                <Wifi className="h-3.5 w-3.5 text-green-600" />
                <span className="text-muted-foreground">
                  {t("signalr.connected")}
                </span>
              </>
            ) : (
              <>
                <WifiOff className="h-3.5 w-3.5 text-gray-400" />
                <span className="text-muted-foreground">
                  {t("signalr.disconnected")}
                </span>
              </>
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {isConnected
              ? t("signalr.tooltip.connected")
              : t("signalr.tooltip.disconnected")}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
